import React, { useState } from 'react';

// import components
import AccordionItem from 'js/components/accordion/Accordion.item';

const AccordionBase = ({ data = [], callback = () => {} }) => {
  const [expanded, setExpanded] = useState(null);

  return (
    <div className={`accordion__base`}>
      {data.map((item, index) => {
        const { id } = item;
        return (
          <AccordionItem key={id} id={id} expanded={expanded} setExpanded={setExpanded} callback={callback} {...item} />
        );
      })}
    </div>
  );
};

export default AccordionBase;
